import React from "react";
import { useTranslation } from "react-i18next";
import style from "./ReplyButton.module.css";
import Icon from "@/ui/icon/Icon";

function ReplyButton({ setIsReplying, isReplying, commentId, replyingTo }) {
	const { t } = useTranslation();

	return (
		<button
			onClick={() =>
				setIsReplying(replyingTo === commentId ? null : commentId)
			}
			className={`${style.replyBtn} ${isReplying ? style.active : ""}`}
		>
			<div className={style.icoHolder}>
				<Icon icon="fa-arrow-turn-down"></Icon>
			</div>
			{t("comments:replyButton.label")}
		</button>
	);
}

export default ReplyButton;
